import { useHistory } from "react-router-dom";
import { ReactElement } from "react";


export type Section = {
    title: string, key: string, path: string,
    render: (selectedStores: string[], compareWithStores: string[]) => ReactElement,
    getPath: () => string,
    isHome?: boolean,
    parent?: string,
    order: number
}

export function SectionItem({section, as, ...rest}: {section: Section | LegacyKelvinSection | LegacyDemoSection, as: React.ElementType, [_: string]: any}) {
    const history = useHistory();
    const Item = as;
    return <Item {...rest} onClick={() => history.push(section.getPath())}>{section.title}</Item>
}

export type LegacyDemoSection = { title: string, key: string, path: string, render: () => JSX.Element, getPath: () => string, isHome?: boolean }

export type LegacyKelvinSection = { title: string, key: string, path: string,
    render: (selectedStores: string[], compareWithStores: string[]) => JSX.Element, getPath: () => string, isHome?: boolean }